var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TwitterLogo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.5459 10.921L30.3413 15.1257C29.4919 24.9722 21.188 32.625 11.25 32.625C9.20813 32.625 7.52485 32.3016 6.24657 31.6632C5.21579 31.1471 4.79392 30.5944 4.68845 30.4369C4.5944 30.2959 4.53345 30.1354 4.51013 29.9675C4.48682 29.7996 4.50175 29.6286 4.55381 29.4673C4.60587 29.3059 4.69372 29.1585 4.81078 29.0359C4.92785 28.9133 5.07111 28.8187 5.22985 28.7592C5.26641 28.7452 8.6386 27.45 10.7803 24.9849C9.59258 24.0083 8.55574 22.8616 7.70345 21.5817C5.9597 18.9928 4.00782 14.4957 4.6097 7.77518C4.62877 7.56164 4.70847 7.35799 4.83941 7.18822C4.97035 7.01845 5.14707 6.88964 5.34876 6.81694C5.55046 6.74424 5.76872 6.73069 5.97786 6.77788C6.187 6.82507 6.3783 6.93104 6.52923 7.08331C6.57845 7.13253 11.2092 11.738 16.8708 13.2314V12.375C16.8686 11.477 17.0462 10.5876 17.393 9.75922C17.7398 8.93084 18.2489 8.18023 18.8902 7.55159C19.513 6.92964 20.2541 6.43874 21.0697 6.10785C21.8853 5.77697 22.759 5.6128 23.6391 5.62503C24.8197 5.63667 25.9772 5.9536 26.9991 6.545C28.021 7.1364 28.8725 7.98215 29.4708 9.00003H33.75C33.9726 8.99985 34.1903 9.06574 34.3755 9.18934C34.5607 9.31295 34.705 9.48871 34.7902 9.69439C34.8754 9.90006 34.8977 10.1264 34.8542 10.3447C34.8107 10.5631 34.7035 10.7636 34.5459 10.921Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLogo);
export default __webpack_public_path__ + "static/media/TwitterLogo.a31b0fa2e7d7cd9208c99575d67a3303.svg";
export { ForwardRef as ReactComponent };